import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { useState as C, useId as w, useEffect as O } from "react";
import { c as B } from "./tw-cn-mXgPecoF.mjs";
import { e as R } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as L } from "./index-BpNK5r1N.mjs";
const E = L(["inline-block shrink-0 animate-loopSpinner"], {
  variants: {
    size: {
      small: "size-20",
      medium: "size-24",
      large: "size-40"
    },
    pcSize: {
      small: "pc:size-20",
      medium: "pc:size-24",
      large: "pc:size-40"
    }
  }
}), P = {
  small: { viewBox: "0 0 20 20", cx: "10", strokeWidth: "3", radius: 8.5, dotR: 1.5 },
  medium: { viewBox: "0 0 24 24", cx: "12", strokeWidth: "3.6", radius: 10.2, dotR: 1.8 },
  large: { viewBox: "0 0 40 40", cx: "20", strokeWidth: "6", radius: 17, dotR: 3 }
}, T = {
  primary: "#4154FF",
  inverse: "#FFFFFF"
}, I = ({
  size: x,
  color: z = "primary",
  className: y,
  delay: r = 300,
  centered: S = !1
}) => {
  const [$, v] = C(r === 0), a = w();
  O(() => {
    if (r === 0) return;
    const k = setTimeout(() => {
      v(!0);
    }, r);
    return () => {
      clearTimeout(k);
    };
  }, [r]);
  const s = R({
    property: x,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: {
      mobile: "medium",
      pc: "large"
    }
  }), h = s.size !== s.pcSize;
  if (!$) return null;
  const F = P[s.size], i = T[z], { cx: e, viewBox: b, strokeWidth: l, radius: o, dotR: g } = F, d = (parseFloat(e) - o).toFixed(1), n = d, c = (parseFloat(e) + o).toFixed(1), m = `loop-spinner-top-${a}`, u = `loop-spinner-bottom-${a}`, f = /* @__PURE__ */ p(
    "svg",
    {
      "aria-busy": "true",
      "aria-label": "loading",
      className: B(
        E({ size: s.size, pcSize: h ? s.pcSize : void 0 }),
        y
      ),
      fill: "none",
      role: "status",
      viewBox: b,
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ p("defs", { children: [
          /* @__PURE__ */ p("linearGradient", { gradientUnits: "userSpaceOnUse", id: m, x1: e, x2: e, y1: c, y2: n, children: [
            /* @__PURE__ */ t("stop", { offset: "0%", stopColor: i, stopOpacity: "0.5" }),
            /* @__PURE__ */ t("stop", { offset: "100%", stopColor: i, stopOpacity: "0" })
          ] }),
          /* @__PURE__ */ p("linearGradient", { gradientUnits: "userSpaceOnUse", id: u, x1: e, x2: e, y1: n, y2: c, children: [
            /* @__PURE__ */ t("stop", { offset: "0%", stopColor: i, stopOpacity: "1" }),
            /* @__PURE__ */ t("stop", { offset: "100%", stopColor: i, stopOpacity: "0.5" })
          ] })
        ] }),
        /* @__PURE__ */ t(
          "path",
          {
            d: `M ${e} ${c} A ${o} ${o} 0 0 1 ${e} ${n}`,
            stroke: `url(#${u})`,
            strokeLinecap: "butt",
            strokeWidth: l
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: `M ${e} ${n} A ${o} ${o} 0 0 1 ${e} ${c}`,
            stroke: `url(#${m})`,
            strokeLinecap: "butt",
            strokeWidth: l
          }
        ),
        /* @__PURE__ */ t("circle", { cx: e, cy: d, fill: i, r: g })
      ]
    }
  );
  return S ? /* @__PURE__ */ t("div", { className: "absolute inset-0 flex items-center justify-center", children: f }) : f;
};
export {
  I as L
};
